<template>
  <div class="page-container content-430">
    <!-- 头部搜索框 start  -->
    <div class="header-wrapper-430">
      <SearchBlock
        ref="searchBlock"
        v-model="searchBlockData"
        :can-operate-data="canOperateData"
        :class-list-search="true"
        @getSearchValue="handleGetSearchValue"
        @handleExportList="handleExportList"
        @cleanFormData="hadnleCleanFormData"
      ></SearchBlock>
      <div class="table-title-special-430 flex justify-content_end">
        <div>
          <!-- 头部搜索框 end  -->
          <div class="ex-btn">
            <Button
              type="primary"
              class="search-430"
              @click="handleBatchSetting"
            >批量设置</Button>
            <Button
              v-if="canOperateData"
              type="primary"
              class="search-430"
              @click="handleAddClass"
            >新建班级</Button>
            <!-- <Button>导出Excel</Button> -->
            <Button
              v-if="canOperateData"
              type="primary"
              class="search-430"
              @click="handleToSmartDivide"
            >智能分班</Button>
            <Button
              v-if="portOrg !== 3"
              type="primary"
              class="search-430"
              @click="handleExportList"
            >导出分班列表</Button>
            <Button
              v-if="portOrg !== 3"
              type="primary"
              class="search-430"
              @click="handleExport('classDetail')"
            >导出分班详情</Button>
            <Button
              v-if="portOrg !== 1"
              type="primary"
              class="search-430"
              @click="handleExport('classSign')"
            >导出班级考勤</Button>
          </div>
        </div>
      </div>
    </div>
    <!-- 课班列表表格部分 start  -->
    <div class="table classlist-table">
      <Table
        ref="selection"
        border
        :max-height="tableHeight"
        :columns="classColumn"
        :data="classData"
        :loading="loadingCourse"
        @on-selection-change="getListSelected"
      >
        <template slot="courseQrCode" slot-scope="{ row }">
          <div class="qr-block">
            <img
              v-if="row.courseQrCode && row.courseQrCode != 0"
              :src="qrCodeIcon"
              alt=""
              @click="handleShowImgList(row.courseQrCode)"
            >
            <span v-else>-</span>
          </div>
        </template>
        <template slot="classroomName" slot-scope="{ row }">
          <TablePoptip :content="row.classroomName"> </TablePoptip>
        </template>

        <template slot="schoolName" slot-scope="{ row }">
          <TablePoptip :content="row.schoolName"> </TablePoptip>
        </template>
        <template slot="orgName" slot-scope="{ row }">
          <TablePoptip :content="row.orgName"> </TablePoptip>
        </template>

        <template slot="relClassroomName" slot-scope="{ row }">
          <TablePoptip :content="row.relClassroomName"> </TablePoptip>
        </template>

        <template slot="action" slot-scope="{ row }">
          <div class="action-block">
            <span class="click-btn-430" @click="handleToDetail(row)">详情</span>
            <span
              v-if="canOperateData"
              class="click-btn-430"
              @click="handleInClass(row)"
            >入班</span>
            <span
              class="click-btn-430"
              @click="handleToAttendancePage(row)"
            >考勤</span>

            <span
              class="click-btn-430"
              @click="handleToNoticePage(row)"
            >发送班级通知</span>
            <span
              v-if="canOperateData && row.registeredNumbers === 0"
              class="del-btn-430"
              @click="handleDelListItem(row)"
            >删除</span>
            <!-- <span class="click-btn-430 error" @click="handleStopClass">停课</span> (v2.0这期不做))-->
          </div>
        </template>
      </Table>
      <Page
        :total="pageInfo.total"
        show-total
        show-sizer
        show-elevator
        :current="pageInfo.pageNum"
        class="page-right"
        :page-size-opts="pageSizeOpts"
        @on-change="handlePageChange"
        @on-page-size-change="handlePageSize"
      ></Page>
    </div>
    <!-- 课班列表表格部分 end  -->
    <!-- 学生入班弹窗 start  -->
    <EnrollStudentDrawer
      ref="EnrollStudentDrawer"
      :classroom-id="selectClassRoomId"
      :rel-classroom-id="selectRelClassRoomId"
      :school-id="selectSchoolId"
      :select-student-row="selectRow"
      :year-code="selectYearCode"
      :term-code="selectTermCode"
      @refreshCurrentPageList="getCourseList"
      @refreshList="initList"
    ></EnrollStudentDrawer>
    <!-- 学生入班弹窗 end  -->
    <Modal
      v-model="showSelectExportModal"
      :footer-hide="true"
      :closable="false"
      title="导出Excel"
    >
      <div>
        <div class="ex-select">
          <RadioGroup v-model="isSelect">
            <Radio label="1" style="margin-right: 40px">已勾选的数据</Radio>
            <Radio label="2">当前筛选结果数据</Radio>
          </RadioGroup>
        </div>
        <div v-if="modalType === 'classDetail'" class="ex-select">
          <RadioGroup v-model="classDetailType">
            <Radio label="1" style="margin-right: 40px">不含离班学生</Radio>
            <Radio label="0">含离班学生</Radio>
          </RadioGroup>
        </div>
        <div v-if="modalType === 'classSign'" class="ex-select">
          <RadioGroup v-model="selectSignType">
            <Radio label="1" style="margin-right: 40px">不含离班学生考勤</Radio>
            <Radio label="0">含离班学生考勤</Radio>
          </RadioGroup>
        </div>
        <div class="price-btn-box">
          <Button @click="handleExCancle">取消</Button>
          <Button type="primary" @click="beforeExport">确定</Button>
        </div>
      </div>
    </Modal>
    <CourseTypeExportModal ref="courseTypeExportModal" :is-select="isSelect" @on-finish="handleSelectSubmit"></CourseTypeExportModal>
    <div>
      <Modal
        v-model="showExportModal"
        title="正在导出"
        :mask-closable="false"
        @on-cancel="handleCancelExport"
      >
        <Progress :percent="percent" :stroke-width="5"></Progress>
        正在导出表格，请给我一些时间，请不要关闭当前页面！
        <div slot="footer">
          <Button @click="handleCancelExport">取消</Button>
        </div>
      </Modal>
    </div>
    <Modal
      v-model="showMemberModal"
      :footer-hide="true"
      :closable="false"
      :width="400"
      title="学生人数"
    >
      <div class="member-box">
        <div class="member-input-main">
          <InputNumber
            v-model="registeredNumbersMin"
            :step="1"
            :min="0"
            placeholder="请输入"
            style="width: 100px"
          ></InputNumber>
          <span style="margin-left: 4px">人</span>
          <span style="margin: 0 8px">~</span>
          <InputNumber
            v-model="registeredNumbersMax"
            :step="1"
            :min="0"
            placeholder="请输入"
            style="width: 100px"
          ></InputNumber>
          <span style="margin-left: 4px">人</span>
        </div>
        <div class="btn-box">
          <Button @click="cancleSearchMember">取消</Button>
          <Button type="primary" @click="handleSearchMember">确定</Button>
        </div>
      </div>
    </Modal>
    <ReviewPhoto ref="reviewPhoto" :img-list="selectImgList"></ReviewPhoto>

    <ClassDetailDrawer
      ref="ClassDetailDrawer"
      @refresh="getCourseList"
    ></ClassDetailDrawer>
    <BatchSetting ref="batchSettingRef" :calss-list="setData"></BatchSetting>
  </div>
</template>
<script>
import {
  tableColumnsWidth,
  key,
  slot,
  renderFn
} from '@/assets/js/resetTableStyle';
import { mapState, mapGetters, mapMutations } from 'vuex';
import ClassDetailDrawer from './assets/components/ClassDetailDrawer.vue';
import SearchBlock from '../assets/components/SearchBlock.vue';
import EnrollStudentDrawer from './assets/components/EnrollStudentDrawer.vue';
import CourseTypeExportModal from './assets/components/CourseTypeExportModal.vue';
import ReviewPhoto from '@c/ReviewPhoto.vue';
import courseSchedulCenter from '@/request/courseSchedulCenter/index.js';
import {
  changeDictionaries,
  courseClassList,
  classroomSubStateList
} from '@/utils/dictionary.js';
import { downLoadByBlob } from '@/pages/assetsModules/common.js';
import axios from 'axios';
import mixinTableHeight from '@/mixins/mixinTableHeight';
import BatchSetting from './components/BatchSetting.vue';
let IntervalId;

export default {
  name: 'CourseSchedulCenterDivideClassManageList',
  components: {
    SearchBlock, // 搜索框组件
    EnrollStudentDrawer, // 学生入班组件
    ReviewPhoto,
    ClassDetailDrawer,
    BatchSetting,
    CourseTypeExportModal
  },
  mixins: [mixinTableHeight],
  // 当是要去详情页面、考勤页面，就保留缓存当前页面组件
  beforeRouteLeave(to, from, next) {
    // if (
    //   to.name === 'courseSchedulCenter_divideClassManage_list_detail' ||
    //   to.name === 'courseSchedulCenter_divideClassManage_list_attendanceRecord'
    // ) {
    //   this.SET_CACHEROUTE(['CourseSchedulCenterDivideClassManageList']);
    // } else {
    //   this.SET_CACHEROUTE([]);
    // }
    this.PUSH_CACHEROUTE('CourseSchedulCenterDivideClassManageList');
    next();
  },
  data() {
    return {
      pageSizeOpts: [10, 20, 50, 100], // 每页条数
      // 课班列表的表头
      classColumn: [
        key(null, null, tableColumnsWidth.type1, {
          type: 'selection',
          fixed: 'left'
        }),
        slot('课程班级名称', 'classroomName', tableColumnsWidth.type6, {
          fixed: 'left'
        }),
        slot('班级群二维码', 'courseQrCode', tableColumnsWidth.type3, {
          align: 'center'
        }),
        key('班级ID', 'classroomId', tableColumnsWidth.type4),

        slot('学校', 'schoolName', tableColumnsWidth.type6),
        key('学期', 'termName', tableColumnsWidth.type4),
        key('课程类别', 'classType', tableColumnsWidth.type2, {
          render: (h, params) => {
            return h('div', [
              changeDictionaries(courseClassList)[params.row.classType]
            ]);
          },
          align: 'center'
        }),
        key('课程分类', 'courseTypeName', tableColumnsWidth.type2, {
          align: 'center'
        }),
        key('商品ID', 'relClassroomId', tableColumnsWidth.type4),
        slot('课程商品名称', 'relClassroomName', tableColumnsWidth.type6),
        slot('提供方', 'orgName', tableColumnsWidth.type6),
        key('学生数', 'registeredNumbers', tableColumnsWidth.type3, {
          renderHeader: (h, params) => {
            const handleFilterNums = () => {
              this.handleShowMemberModal();
            };
            return h(
              'div',
              {
                style: {
                  display: 'flex',
                  alignItems: 'center'
                }
              },
              [
                h('span', ['学生数']),
                h('Icon', {
                  on: {
                    // 单元格的点击事件
                    click: handleFilterNums
                  },
                  style: { marginLeft: '8px', cursor: 'pointer' },
                  props: {
                    type: 'ios-search',
                    size: 24,
                    color: '#ccc'
                  }
                })
              ]
            );
          },
          align: 'center'
        }),
        key('上课时间', 'timeDesc', tableColumnsWidth.type4, {
          render: (h, params) => {
            return h(
              'TablePoptip',
              {
                props: {
                  content: params.row.timeDesc,
                  showPoptipsContentLength: 30,
                  contentWidth: 230
                }
              },
            );
          }
        }),
        key('开课日期', 'classDateBegin', tableColumnsWidth.type9, {
          render: (h, params) => {
            return h('div', [params.row.classDateBegin.split(' ')[0]]);
          },
          align: 'center'
        }),

        key('总课次', 'classroomTotal', tableColumnsWidth.type9, {
          align: 'center'
        }),
        key('上课场地', 'placeName', tableColumnsWidth.type6),
        key('负责教师', 'teacherDesc', tableColumnsWidth.type5, {
          render: (h, params) => {
            return renderFn(h, params);
          }
        }),

        key('班级状态', 'courseState', tableColumnsWidth.type2, {
          render: (h, params) => {
            return h('div', [
              changeDictionaries(classroomSubStateList)[params.row.courseState]
            ]);
          },
          align: 'center'
        }),
        slot('操作', 'action', 270, { fixed: 'right' })
      ],
      classData: [], // 课班列表数据
      pageInfo: {
        total: 0,
        pageNum: 1,
        pageSize: 10
      }, // 课班列表分页信息
      searchData: {}, // 从搜索框组件拿到的搜索入参
      selectClassRoomId: '', // 选择的某一行的课班id
      selectTermCode: '',
      selectYearCode: '',
      selectRelClassRoomId: '', // 选择的某一行的商品id
      selectSchoolId: '', // 选择的某一行的学校id
      portOrg: -1, // 处于哪个端
      showSelectExportModal: false,
      showExportModal: false,
      percent: 0, // 进度条,
      isSelect: '1', // 导出选择
      classDetailType: '1', // 分班详情-导出离班选择
      setData: [], // 勾选数据
      classroomIdStr: [], // 勾选id
      source: '', // 取消请求 CancelToken的一个工厂方法source
      loadingCourse: false, // 是否在请求课班列表数据
      selectRow: {}, // 选中的某行数据
      searchBlockData: {},
      selectSignType: '1', // 1:不含离班学生考勤 2:含离班学生考勤
      modalType: '', // classDetail,classSign,// 两个类型
      activeInNums: 0,
      showMemberModal: false,
      memberFilter: null,
      selectImgList: [],
      qrCodeIcon: require('@/assets/img/qrcode.svg'),
      registeredNumbersMin: null, // 检索报名人数多少个以上的 前置条件
      registeredNumbersMax: null, // 检索报名人数多少个以上的   后置条件
      nextClassReminder: '',
      typeList: []
    };
  },
  computed: {
    ...mapState(['userInfo']),
    ...mapGetters(['theUserIdentity', 'routeTitle']),
    // 是否可以操作数据(分端权限)
    canOperateData() {
      // 只有运营端和学校端可以操作数据
      if (this.portOrg === 0 || this.portOrg === 2) {
        return true;
      }
      return false;
    }
  },
  created() {
    this.portOrg = Number(localStorage.getItem('portOrg'));
    // this.getCourseList();
  },
  activated() {
    this.getCourseList();
  },
  methods: {
    ...mapMutations(['SET_CACHEROUTE', 'PUSH_CACHEROUTE']),
    handleBatchSetting() {
      if (this.setData.length == 0) {
        this.$Message.warning('请先选择班级～');
        return false;
      }
      this.$refs.batchSettingRef.handleShow();
    },
    // 重置搜索表单
    hadnleCleanFormData() {
      this.registeredNumbersMin = null;
      this.registeredNumbersMax = null;
    },
    // 获取搜索组件传来的搜索入参
    handleGetSearchValue(searchData) {
      console.log('searchData', searchData);
      this.pageInfo.pageNum = 1;
      this.searchData = { ...searchData, studentTotal: this.memberFilter };
      this.searchData.classType === '0'
        ? (this.searchData.classType = null)
        : '';
      this.getCourseList();
    },
    // 点击分页页码
    handlePageChange(page) {
      this.pageInfo.pageNum = page;
      this.getCourseList();
    },
    // 页条数改变
    handlePageSize(pageSize) {
      this.pageInfo.pageSize = pageSize;
      this.pageInfo.pageNum === 1 && this.getCourseList();
    },
    // 点击跳转到详情页面
    handleToDetail(row) {
      // const { href } = this.$router.resolve({
      //   name: 'courseSchedulCenter_divideClassManage_list_detail',
      //   query: { classroomId: row.classroomId }
      // });
      // window.open(href);
      this.$nextTick(() => {
        this.$refs.ClassDetailDrawer.openDetailsDrawer(row.classroomId);
      });
      // this.$router.push({
      //   name: 'courseSchedulCenter_divideClassManage_list_detail',
      //   query: { classroomId: row.classroomId }
      // });
    },
    // 点击跳转到考勤页面
    handleToAttendancePage(row) {
      // const { href } = this.$router.resolve({
      //   name: 'courseSchedulCenter_divideClassManage_list_attendanceRecord',
      //   query: { classroomId: row.classroomId }
      // });
      // window.open(href);
      // this.$Message.warning('功能暂不可用');
      // return;
      this.$router.push({
        name: 'courseSchedulCenter_divideClassManage_list_attendanceRecord',
        query: { classroomId: row.classroomId }
      });
    },
    // 点击跳转到发布通知公告页面
    handleToNoticePage(row) {
      console.log('跳转', row);
      // const { href } = this.$router.resolve({
      //   name: 'courseSchedulCenter_divideClassManage_list_addnotice',
      //   query: { type: 'classtoadd', item: JSON.stringify(row), orgId: row.schoolId }
      // });
      // window.open(href);
      this.$router.push({
        name: 'courseSchedulCenter_divideClassManage_list_addnotice',
        query: {
          type: 'classtoadd',
          item: JSON.stringify(row),
          orgId: row.schoolId
        }
      });
    },
    // 删除班级列表的某项
    handleDelListItem(row) {
      this.$Modal.confirm({
        title: '提示',
        content: `是否删除${row.classroomName}？删除后不可恢复！`,
        onOk: () => {
          this.delListItemTrue(row);
        }
      });
    },
    // 真正的删除
    async delListItemTrue(row) {
      const params = {
        classroomId: row.classroomId
      };
      const res = await courseSchedulCenter.delCourseClassItemApi(params);
      if (res.status === 200) {
        this.$Message.success('删除成功');
        this.getCourseList();
      }
    },
    // 点击按钮停课(v2.0这期不做)
    handleStopClass() { },
    // 点击入班按钮
    handleInClass(row) {
      // this.$Message.error('功能暂不可用!');
      // return;
      console.log('row', row);
      this.selectClassRoomId = row.classroomId;
      this.selectRelClassRoomId = row.relClassroomId;
      this.selectSchoolId = row.schoolId;
      this.selectYearCode = row.yearCode;
      this.selectTermCode = row.termCode;
      this.selectRow = row;
      this.$nextTick(() => {
        this.$refs.EnrollStudentDrawer.open();
      });
    },
    // 操作数据之后刷新课班列表
    initList() {
      this.pageInfo = {
        total: 1,
        pageNum: 1,
        pageSize: 10
      };
      this.getCourseList();
    },
    // 获取列表信息
    async getCourseList() {
      const params = {
        pageNum: this.pageInfo.pageNum,
        pageSize: this.pageInfo.pageSize
      };
      const paramsData = Object.assign(this.searchData, params);
      paramsData.registeredNumbersMin = this.registeredNumbersMin;
      paramsData.registeredNumbersMax = this.registeredNumbersMax;
      if (this.$route.query.classTeachingStatus) {
        paramsData.classTeachingStatus = this.$route.query.classTeachingStatus;
      }
      try {
        this.loadingCourse = true;
        const res = await courseSchedulCenter.getCourseClassList(paramsData);
        if (res.status === 200) {
          this.classData = res.message.list;
          this.pageInfo.total = Number(res.message.total);
          this.setData = [];
          this.classroomIdStr = '';
        }
      } catch (err) {
        console.log(err);
      } finally {
        this.loadingCourse = false;
      }
    },
    // 点击新建课班
    handleAddClass() {
      this.$router.push({
        name: 'courseSchedulCenter_divideClassManage_list_addClass'
      });
    },
    // 点击跳转到智能分班页面
    handleToSmartDivide() {
      this.$router.push({
        name: 'courseSchedulCenter_divideClassManage_list_smartDivideClass'
      });
    },
    // 导出-弹框
    handleExport(type) {
      console.log(this.searchData, this.theUserIdentity);
      if (!this.searchData['schoolId'] && this.theUserIdentity != 'school') {
        this.$Message.warning('请选择学校');
        return null;
      }
      this.isSelect = '1';
      this.classDetailType = '1';
      this.modalType = type;
      if (
        (!this.searchData['yearCode'] || !this.searchData['termCode']) &&
        this.modalType === 'classSign'
      ) {
        this.$Message.warning('请选择学期');
        return null;
      }
      this.showSelectExportModal = true;
    },
    // 导出-导出分班列表
    async handleExportList() {
      this.$refs.searchBlock.emitData();
      console.log('searchData', this.searchBlockData);
      if (!this.searchData['yearCode'] || !this.searchData['termCode']) {
        this.$Message.warning('请先选择学期并查询出列表后再进行导出');
        return null;
      }
      const params = {
        pageNum: 1,
        pageSize: 10000
      };
      const { classType, ...otherInfo } = this.searchBlockData;
      const paramsData = Object.assign({}, otherInfo, params);
      +classType === 1 || +classType === 2 ? paramsData.classType = classType : '';
      this.percentShow();
      this.showExportModal = true;
      const CancelToken = axios.CancelToken;
      this.source = CancelToken.source();
      const res = await courseSchedulCenter.pageExport(
        paramsData,
        this.source.token
      );
      if (res) {
        const reader = new FileReader();
        let resData = null;
        reader.readAsText(res.data, 'utf-8');
        reader.onload = () => {
          if (res.data.type === 'application/vnd.ms-excel') {
            this.$Message.success('导出成功');
            clearInterval(IntervalId);
            this.percent = 100;
            setTimeout(() => {
              this.showExportModal = false;
              this.showSelectExportModal = false;
            }, 500);
            downLoadByBlob(res);
          } else {
            resData = JSON.parse(reader.result);
            clearInterval(IntervalId);
            this.percent = 60;
            setTimeout(() => {
              this.showExportModal = false;
            }, 500);
            this.$Message.error(resData.error);
          }
        };
      } else {
        this.showExportModal = false;
      }
    },
    // 导出-取消
    handleExCancle() {
      this.showSelectExportModal = false;
    },
    beforeExport() {
      if (this.isSelect == 1 && this.setData.length == 0) {
        this.$Message.error('请至少勾选一条记录');
        return false;
      }
      this.$refs.courseTypeExportModal.getExReset();
      this.$refs.courseTypeExportModal.handleShow();
    },
    handleSelectSubmit(info) {
      // const reData = this.$refs.courseTypesRef.getResult();
      this.typeList = info.courseTypesData.typeIds;
      this.nextClassReminder = info.nextClassReminder;
      if (this.typeList.length == 0 && this.isSelect !== '1') {
        this.$Message.error('请至少勾选一个班级课程类型');
        return false;
      }
      this.$refs.courseTypeExportModal.handleHide();
      this.handleExSubmit();
    },
    // 导出-确定
    async handleExSubmit() {
      const params = {
        pageNum: 1,
        pageSize: 100,
        classroomIdStr: this.classroomIdStr
        // classroomIdStr: "123, 456, 789"
      };
      const paramsData = Object.assign(this.searchData, params);
      if (this.nextClassReminder) {
        paramsData.nextClassReminder = this.nextClassReminder;
      }
      if (this.typeList && this.typeList.length > 0) {
        paramsData.courseTypeKinds = this.typeList.join(',');
      }
      if (this.isSelect != 1) {
        (paramsData.pageSize = this.pageInfo.total),
        delete paramsData['classroomIdStr'];
      }
      this.percentShow();
      this.showExportModal = true;
      const CancelToken = axios.CancelToken;
      this.source = CancelToken.source();
      let res = null;
      if (this.modalType === 'classDetail') {
        const data = {
          ...paramsData,
          studentSts: this.classDetailType === '0' ? '' : this.classDetailType // 1 在班学生, 为空包含离班学生
        };
        res = await courseSchedulCenter.getClassexportExcel(
          data,
          this.source.token
        );
      } else if (this.modalType === 'classSign') {
        const data = {
          ...paramsData,
          studentSts: this.selectSignType === '0' ? null : this.selectSignType,
          classroomIds: this.isSelect !== '1' ? null : this.classroomIdStr
        };
        this.portOrg === 2 ? (data.schoolId = this.userInfo.orgId) : '';
        res = await courseSchedulCenter.getAttendanceListExcelApi(
          data,
          this.source.token
        );
      } else {
        this.showExportModal = false;
      }
      if (res) {
        const reader = new FileReader();
        let resData = null;
        reader.readAsText(res.data, 'utf-8');
        reader.onload = () => {
          if (res.data.type === 'application/vnd.ms-excel') {
            this.$Message.success('导出成功');
            clearInterval(IntervalId);
            this.percent = 100;
            setTimeout(() => {
              this.showExportModal = false;
              this.showSelectExportModal = false;
            }, 500);
            downLoadByBlob(res);
          } else {
            resData = JSON.parse(reader.result);
            clearInterval(IntervalId);
            this.percent = 60;
            setTimeout(() => {
              this.showExportModal = false;
            }, 500);
            this.$Message.error(resData.error);
          }
        };
      } else {
        this.showExportModal = false;
      }
    },
    // 导出进度条模态框提示
    percentShowFun() {
      this.percent += 20;
      if (this.percent >= 80) {
        clearInterval(IntervalId);
      }
    },
    percentShow() {
      this.percent = 0;
      IntervalId = setInterval(this.percentShowFun, 500);
    },
    // 导出-进度条
    handleCancelExport() {
      this.source.cancel('取消请求');
    },
    // 勾选列表数据
    getListSelected(selection) {
      this.setData = selection;
      var arr = [];
      selection.forEach(item => {
        arr.push(item.classroomId);
      });
      this.classroomIdStr = [...new Set(arr)].join(',');
    },
    handleShowMemberModal() {
      this.showMemberModal = true;
    },
    handleSearchMember() {
      //  this.searchData.studentTotal = this.memberFilter;
      const arr = [this.registeredNumbersMin, this.registeredNumbersMax];
      if (
        arr.filter(item => {
          return item === null;
        }).length == 1
      ) {
        if (this.registeredNumbersMin > this.registeredNumbersMax) {
          this.$Message.warning('需要填写完整的数值区间，才能进行查询');
          return null;
        }
      }
      if (this.registeredNumbersMin > this.registeredNumbersMax) {
        this.$Message.warning('报名人数区间，只能按小到大数字值填写');
        return null;
      }
      this.searchData['registeredNumbersMax'] = this.registeredNumbersMax;
      this.searchData['registeredNumbersMin'] = this.registeredNumbersMin;
      this.handlePageChange(1);
      this.showMemberModal = false;
    },
    cancleSearchMember() {
      this.registeredNumbersMax = this.searchData.registeredNumbersMax;
      this.registeredNumbersMin = this.searchData.registeredNumbersMin;
      this.showMemberModal = false;
      //   this.memberFilter = this.searchData.studentTotal;
    },
    // 点击打开照片
    handleShowImgList(img) {
      this.selectImgList = [img];
      this.$nextTick(() => {
        this.$refs.reviewPhoto.open();
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.table-box {
  margin-top: 32px;
}
.page-right {
  text-align: right;
  margin-top: 16px;
}
.classlist-table {
  /deep/.ivu-table-wrapper {
    overflow: visible;
  }
}

.action-block {
  // span {
  //   color: #488ffa;
  // }
  // .error {
  //   color: rgb(255, 92, 92);
  // }
  span + span {
    margin-left: 8px;
  }
}
.ex-select {
  display: flex;
  text-align: center;
  justify-content: center;
  margin-bottom: 20px;
  /deep/.ivu-radio-wrapper {
    width: 150px;
    text-align: left;
  }
}
.price-btn-box {
  display: flex;
  justify-content: flex-end;
  button + button {
    margin-left: 24px;
  }
}
.item-box-430 {
  .ex-btn {
    text-align: right;
    margin: 20px 0;
  }
}
.member-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  .member-input-main {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .btn-box {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 16px;
    button + button {
      margin-left: 16px;
    }
  }
}
.qr-block {
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    width: 24px;
    height: 24px;
  }
}
</style>
<style lang="scss">
.time-line-courselist {
  line-height: 24px;
  padding: 8px 0;
}
</style>
